import { Pipe, PipeTransform } from '@angular/core';

const minutesPerHour = 60;

@Pipe({
    name: 'formatDuration',
    standalone: false,
})
export class FormatDurationPipe implements PipeTransform {
    /**
     * Formats a duration given in minutes as "HH:mm", or as "1h 30m" for the timesheet screen.
     *
     * The duration is rounded to whole minutes before it is split into hours and minutes. Callers
     * often arrive at their minutes through floating-point arithmetic — hours converted back to
     * minutes, or fractions summed up — and land a hair below the whole minute they mean
     * (11 minutes becoming 10.999…). Truncating that would drop a full minute from the display,
     * which is how the weekly work time panel and the timesheet came to disagree.
     *
     * @param durationInMinutes the duration in minutes
     * @param timeSheetEntry whether to use the timesheet screen's "1h 30m" format
     * @returns the formatted duration, or an empty string for a negative or unusable duration
     */
    public transform(durationInMinutes: number, timeSheetEntry = false): string {
        const totalMinutes = Math.round(durationInMinutes);
        if (!Number.isFinite(totalMinutes) || totalMinutes < 0) {
            return '';
        }

        const hours = Math.floor(totalMinutes / minutesPerHour);
        const minutes = totalMinutes % minutesPerHour;

        if (timeSheetEntry) {
            // For the timesheet screen, decided to keep the same format as in the crm-time-recording screen.
            return `${hours}h ${minutes}m`;
        }
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }
}
